const isNonEmptyString = (value) =>
  typeof value === 'string' && value.trim().length > 0;

// Owner-confirmed compatibility: inclusive +/-1 cent on the final total.
// Never modify an issued capability to eliminate a rounding difference.
export const EMBEDDED_AMOUNT_TOLERANCE_CENTS = 1;

const getMissingEmbeddedCheckoutFields = (checkoutData = {}) => {
  const missingFields = [];

  if (!isNonEmptyString(checkoutData.clientSecret)) {
    missingFields.push('clientSecret');
  }
  if (!isNonEmptyString(checkoutData.publishableKey)) {
    missingFields.push('publishableKey');
  }
  if (!isNonEmptyString(checkoutData.paymentIntentId)) {
    missingFields.push('paymentIntentId');
  }
  if (!Number.isSafeInteger(checkoutData.amount) || checkoutData.amount <= 0) {
    missingFields.push('amount');
  }

  return missingFields;
};

export default getMissingEmbeddedCheckoutFields;
